// extracted by mini-css-extract-plugin
export default {"contentBaseWrapper":"contentBaseWrapper___rssLF","withViewInPageButton":"withViewInPageButton___DrV7O","withoutViewInPageButton":"withoutViewInPageButton___ysM7d"};